import _extends from "@babel/runtime/helpers/extends";
import { TextV2 as Base } from "@cancer-council-queensland/react";
import { jsx as _jsx } from "react/jsx-runtime";
export var TextV2 = props => {
  var _props$children;

  return /*#__PURE__*/_jsx(Base, _extends({}, props, {
    content: ((_props$children = props.children) == null ? void 0 : _props$children.content) || ""
  }));
};
//# sourceMappingURL=text_v2.js.map